export const instantAppId = "38695e7e-368c-49d5-8630-26b271f02d1f";
export const posthogId = "phc_tQ9334EGu96ZEIYzrGPzk1X9VquSqSS6GrAJrXIIAWI";

export const monthlyPaymentPerLine = 10;
export const dailyMessageCap = 250;
export const supportEmail = "support@supergreen.cc";
export const ownerEmail = "uri.valevski@gmail.com";
